




































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WelcomeCoin extends Vue {
  @Prop({ default: '74' }) readonly width?: string;
  @Prop({ default: '75' }) readonly height?: string;
}
